// LiveStreamUserEnteredNotice.js
'use strict';
import { connect } from 'react-redux';
import getUserData from '../selector/getUserData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';
import getVipLevelLivestreamChatStyle from '../selector/getVipLevelLivestreamChatStyle.js';
import fetchUser from '../action/fetchUser.js';
import LiveStreamUserEnteredNotice from '../component/LiveStreamUserEnteredNotice.jsx';
import { livestreamNoticeType } from '../resource/liveStreamConstants.js';
import {
  FEATURE_DISPLAY_NAME,
  VIP_LEVEL_LIVESTREAM_NOTIFY_THRESHOLD,
} from '../RemoteConfigKeys.js';
import {
  getVipBenefitLevelThresholdByUserLevel,
  getUserLevelBenefitThresholdList,
} from '../selector/getUserLevelBenefitData.js';
import getVipLevelLivestreamStyleList from '../selector/getVipLevelLivestreamStyleList.js';
import getEntrancePagUrl from '../selector/getEntrancePagUrl.js';
import { resolvePagPlay } from '../resource/pagPlayRegistry.js';

const mapStateToProps = (state, { streamId }) => {
  const noticeType = livestreamNoticeType.USER_ENTERED_NOTICE;
  const userEnteredNoticeIds =
    getListData(state, ['liveStream', streamId, noticeType], 'itemIds') || [];
  const userEnteredNoticeId = userEnteredNoticeIds[0];
  const userEnteredNoticeSelectPath = [
    streamId,
    noticeType,
    userEnteredNoticeId,
  ];
  const noticeStatus = getLiveStreamData(
    state,
    userEnteredNoticeSelectPath,
    'status'
  );
  const userId = getLiveStreamData(
    state,
    userEnteredNoticeSelectPath,
    'userId'
  );
  const level = getLiveStreamData(state, userEnteredNoticeSelectPath, 'level');
  const username = getUserData(state, userId, 'username');
  const displayName = getUserData(state, userId, 'displayName');
  const isUserFetching = userId
    ? getNetworkingData(state, ['user', userId], 'isFetching')
    : false;
  const isUserFetched = userId
    ? getNetworkingData(state, ['user', userId], 'isFetched')
    : false;
  const isDisplayNameEnabled = getRemoteConfigData(state, FEATURE_DISPLAY_NAME);
  const senderBadges = getLiveStreamData(
    state,
    userEnteredNoticeSelectPath,
    'senderBadges'
  );
  const vipLevelLivestreamNotifyThreshold = getRemoteConfigData(
    state,
    VIP_LEVEL_LIVESTREAM_NOTIFY_THRESHOLD
  );
  const { vipBenefitLevel: minRequiredVipBenefitLevel } =
    getVipBenefitLevelThresholdByUserLevel(
      state,
      vipLevelLivestreamNotifyThreshold
    );
  const userLevelBenefitThresholdList = getUserLevelBenefitThresholdList(state);
  const maxVipBenefitLevel =
    userLevelBenefitThresholdList[userLevelBenefitThresholdList.length - 1]
      ?.level ?? 0;
  const vipLevelLivestreamStyleList = getVipLevelLivestreamStyleList(
    state,
    minRequiredVipBenefitLevel,
    maxVipBenefitLevel
  );
  const { vipEnteredNoticeStyle } = getVipLevelLivestreamChatStyle(
    state,
    level,
    minRequiredVipBenefitLevel,
    vipLevelLivestreamStyleList
  );

  const entrancePagUrl = getEntrancePagUrl(state, level);

  return {
    noticeId: userEnteredNoticeId,
    userId,
    username,
    displayName,
    isUserFetching,
    isUserFetched,
    isDisplayNameEnabled,
    noticeStatus,
    level,
    senderBadges,
    vipEnteredNoticeStyle,
    entrancePagUrl,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUser: ({ userId }) => dispatch(fetchUser({ id: userId })),
    onPagPlay: noticeId => resolvePagPlay({ noticeId }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamUserEnteredNotice);
